import PropTypes from "prop-types";
import React from "react";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";

class ContentGroupNavigator extends React.PureComponent {
  static get propTypes() {
    return {
      index: PropTypes.number,
      totalElements: PropTypes.number,
      onNavigate: PropTypes.func,
    };
  }

  static get defaultProps() {
    return {
      index: 0,
      onNavigate: () => {},
    };
  }

  render() {
    const { index, totalElements, onNavigate } = this.props;

    return (
      <div className="cg-navigator">
        <Row>
          <Col xs={12}>
            <div className=" button-spacing">
              <Button
                variant="default"
                disabled={index === 0}
                onClick={() => onNavigate(-1)}
                title="Previous item"
              >
                <i className="fa fa-angle-left" aria-hidden="true" />
              </Button>
              <Button
                variant="default"
                disabled={index === totalElements - 1}
                className="pull-right"
                onClick={() => onNavigate(1)}
                title="Next item"
              >
                <i className="fa fa-angle-right" aria-hidden="true" />
              </Button>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}

export { ContentGroupNavigator };
